@if (!add) {
  <div class="sp-img-grid">
    <div class="sp-img-card">
      <span class="sp-img-label">Box</span>
      <img
        #image_box
        [src]="img_box || (spettacolo?.img_box ? (spettacolo!.img_box + '?type=spettacolo' | image) : '../../../../../assets/images/Noimage.png')"
        (error)="image_box.src='../../../../../assets/images/Noimage.png'"
        alt="Box"
        class="sp-img-preview"
      />
      <button type="button" class="acc-btn w-full" (click)="onCarica('box')">Carica foto box</button>
    </div>

    <div class="sp-img-card">
      <span class="sp-img-label">Home</span>
      <img
        #image_home
        [src]="img_home || (spettacolo?.img_home ? (spettacolo!.img_home + '?type=spettacolo' | image) : '../../../../../assets/images/Noimage.png')"
        (error)="image_home.src='../../../../../assets/images/Noimage.png'"
        alt="Home"
        class="sp-img-preview"
      />
      <button type="button" class="acc-btn w-full" (click)="onCarica('home')">Carica foto home</button>
    </div>

    <div class="sp-img-card">
      <span class="sp-img-label">Copertina</span>
      <img
        #image_cover
        [src]="img_cover || (spettacolo?.img_copertina ? (spettacolo!.img_copertina + '?type=spettacolo' | image) : '../../../../../assets/images/Noimage.png')"
        (error)="image_cover.src='../../../../../assets/images/Noimage.png'"
        alt="Copertina"
        class="sp-img-preview"
      />
      <button type="button" class="acc-btn w-full" (click)="onCarica('cover')">Carica foto copertina</button>
    </div>
  </div>
}

@if (add && tipo === 'box') {
  <app-image-cropper [type]="'box'" [aspect_ratio]="1/1" [height]="700" [width]="700" [accept]="'image/*'" (onCrop)="onRitaglio($event)"></app-image-cropper>
  <div class="sp-img-actions">
    <button type="button" class="acc-btn acc-btn-primary" (click)="onConferma()">Ritaglia</button>
    <button type="button" class="acc-btn acc-btn-ghost" (click)="add=false">Annulla</button>
  </div>
}

@if (add && tipo === 'home') {
  <app-image-cropper [aspect_ratio]="970/770" [height]="970" [width]="770" accept="image/*" (onCrop)="onRitaglio($event)"></app-image-cropper>
  <div class="sp-img-actions">
    <button type="button" class="acc-btn acc-btn-primary" (click)="onConferma()">Ritaglia</button>
    <button type="button" class="acc-btn acc-btn-ghost" (click)="add=false">Annulla</button>
  </div>
}

@if (add && tipo === 'cover') {
  <app-image-cropper [type]="'cover'" [aspect_ratio]="1900/870" [height]="870" [width]="1900" [accept]="'image/*'" (onCrop)="onRitaglio($event)"></app-image-cropper>
  <div class="sp-img-actions">
    <button type="button" class="acc-btn acc-btn-primary" (click)="onConferma()">Ritaglia</button>
    <button type="button" class="acc-btn acc-btn-ghost" (click)="add=false">Annulla</button>
  </div>
}
